import { Suspense } from 'react';

import { IconCreditCardFilled } from '@iwoca/icons';
import { Text } from '@iwoca/orion';
import { Skeleton } from '@ui';
import { FormattedMessage } from 'react-intl';

import { useGetCompletedDebitCard } from './useGetCompletedDebitCard';

export const DebitCardCompletedView = () => {
    return (
        <div className="space-y-s">
            <Text className="text-m font-med text-primary-10">
                <FormattedMessage
                    id="_.funding_requirements.debit_card_step.list_title"
                    defaultMessage="Add your debit card for repayments"
                />
            </Text>
            <Suspense fallback={<Skeleton className="h-m w-[200px]" />}>
                <CardSummary />
            </Suspense>
        </div>
    );
};

const CardSummary = () => {
    const { lastDigits } = useGetCompletedDebitCard();

    // Card details unavailable despite a completed status; the green pill
    // already signals success, so render nothing rather than throwing.
    if (!lastDigits) return null;

    return (
        <div className="flex items-center gap-s text-s font-reg text-structure-40">
            <IconCreditCardFilled className="text-l" />
            {`**** **** **** ${lastDigits}`}
        </div>
    );
};
